import styled from 'styled-components';
import Button from '../../Button/Button';
import { mediaBelow } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';
// Single source of truth for the Sell-From-Home primary CTA across every SFH
// screen: 16px / 600 weight / #052D6B background when enabled. The variant and
// textTransform are pinned via .attrs so a screen can't opt out, and `&&`
// outranks Button's own base + mediaBelow(bpMd) font-size/weight rules so the
// spec holds at every breakpoint without per-screen specificity hacks.
//
// Background (#052D6B) and the enabled/disabled colors come from the `primary`
// variant's themeColors tokens — do not hardcode them here. Layout concerns
// (width, row arrangement) stay with each screen's footer wrapper.
const SfhPrimaryButton = styled(Button).attrs({
  variant: 'primary',
  textTransform: 'none',
})`
  && {
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
  ${mediaBelow(variables.breakpoints.bpMd)} {
    height: 44px;
  }
`;

export default SfhPrimaryButton;
